import { BriefDisplayStatus, Gql } from '@fiverr-private/dynamic_matching';

type BriefItemResponse = NonNullable<Gql.GetBriefsListQuery['dmBriefsByContext']['nodes']>[number];

export interface BriefItem extends Omit<BriefItemResponse, 'customOffersMetrics'> {
    briefDisplayStatus: BriefDisplayStatus;
    hiredCount: number;
    offersCount: number;
}

export interface BriefsList {
    totalCount: number;
    nodes: BriefItem[];
    pageInfo: Pick<Gql.PageInfo, 'endCursor' | 'hasNextPage'>;
}

export enum BriefAction {
    VIEW_BRIEF = 'VIEW_BRIEF',
    INVITE_FREELANCERS = 'INVITE_FREELANCERS',
    MANAGE_BRIEF = 'MANAGE_BRIEF',
}
